var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_4391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0172 1.71632C7.72892 -0.571945 4.00459 -0.571945 1.71632 1.71632C-0.571455 4.00509 -0.571455 7.72892 1.71632 10.0177C3.75408 12.055 6.9278 12.2732 9.21458 10.6824C9.2627 10.9101 9.37282 11.1274 9.54991 11.3044L12.8824 14.6369C13.368 15.1215 14.1527 15.1215 14.6359 14.6369C15.121 14.1518 15.121 13.367 14.6359 12.8834L11.3034 9.54992C11.1273 9.37432 10.9096 9.2637 10.6819 9.21558C12.2737 6.9283 12.0555 3.75508 10.0172 1.71632ZM8.96507 8.96557C7.25668 10.674 4.47633 10.674 2.76844 8.96557C1.06104 7.25718 1.06104 4.47733 2.76844 2.76894C4.47633 1.06105 7.25668 1.06105 8.96507 2.76894C10.6735 4.47733 10.6735 7.25718 8.96507 8.96557Z",
    fill: "#939191"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_4391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.35d920d990ec3b987cbdbf3813d1ef34.svg";
export { ForwardRef as ReactComponent };